// extracted by mini-css-extract-plugin
module.exports = {"root":"root--HaZB-","list":"list--ihdXK"};